import { NgModule } from '@angular/core';
import { VerifyComponent } from './verify.component';

@NgModule({
    declarations: [VerifyComponent],
    exports: [VerifyComponent]
})
export class VerifyModule { }
